// extracted by mini-css-extract-plugin
module.exports = {"col":"col--9vIEP"};